import Icon from "@amzn/meridian/icon";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import clipboardTokens from "@amzn/meridian-tokens/base/icon/clipboard";
import documentTokens from "@amzn/meridian-tokens/base/icon/document";
import metricsTokens from "@amzn/meridian-tokens/base/icon/metrics";
import { formatCount } from "../adminReportUtils";
import { OverviewTotals } from "../types";
import { ChipTone } from "./chip";

interface StatCard {
  label: string;
  caption: string;
  value: string;
  tokens: any;
  tone: ChipTone;
  /** Present when the card is an entry point into another tab. */
  action?: { label: string; onClick: () => void };
}

interface StatCardsProps {
  totals: OverviewTotals;
  onUncoveredClick: () => void;
  onFailedClick: () => void;
}

const StatCards = ({
  totals,
  onUncoveredClick,
  onFailedClick,
}: StatCardsProps) => {
  const cards: StatCard[] = [
    {
      label: "Total Documents",
      caption: "All regions",
      value: formatCount(totals.totalDocuments),
      tokens: documentTokens,
      tone: "blue",
    },
    {
      label: "Total Test Cases",
      caption: "All regions",
      value: formatCount(totals.totalTestCases),
      tokens: clipboardTokens,
      tone: "green",
    },
    {
      label: "Overall Pass Rate",
      caption: "Avg across regions",
      value: `${totals.averagePassRate}%`,
      tokens: metricsTokens,
      tone: "teal",
    },
    {
      label: "Failed Test Cases",
      caption: "Requires review",
      value: formatCount(totals.failedTestCases),
      tokens: alertTokens,
      tone: "red",
      action: { label: "View failures ↗", onClick: onFailedClick },
    },
    {
      label: "Uncovered Documents",
      caption: "Need attention",
      value: formatCount(totals.uncoveredDocuments),
      tokens: alertTokens,
      tone: "amber",
      action: { label: "View documents ↗", onClick: onUncoveredClick },
    },
  ];

  return (
    <div className="admin-report__stats">
      {cards.map(({ label, caption, value, tokens, tone, action }) => {
        const body = (
          <>
            <div className="admin-report__stat-top">
              <span
                className={`admin-report__stat-icon admin-report__tone--${tone}`}
              >
                <Icon tokens={tokens} />
              </span>
              <span className="admin-report__stat-caption">{caption}</span>
            </div>
            <div className="admin-report__stat-value">{value}</div>
            <div className="admin-report__stat-label">{label}</div>
            {action && (
              <div className="admin-report__stat-link">{action.label}</div>
            )}
          </>
        );

        return action ? (
          <button
            key={label}
            type="button"
            className="admin-report__stat admin-report__stat--clickable"
            onClick={action.onClick}
          >
            {body}
          </button>
        ) : (
          <div key={label} className="admin-report__stat">
            {body}
          </div>
        );
      })}
    </div>
  );
};

export default StatCards;
